import { useQueryClient } from '@tanstack/react-query';
import { MY_DESIGNS_QUERY_KEY } from './my-designs-query-key';

/** 내 디자인 목록 무효화 — 삭제·복제·이름 변경 뒤 첫 페이지부터 다시 읽는다. 재조회 promise 를 돌려준다. */
export const useInvalidateMyDesigns = (): (() => Promise<void>) => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: MY_DESIGNS_QUERY_KEY });
};
